/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-use-before-define */
import moment from 'moment';
import { isEmpty } from 'ramda';
import * as React from 'react';
import { Icon, Input, Modal } from '../..';
import {
  getLocallySavedSales,
  removeLocallyStoredSale,
} from '../../../context/storeContext';
import { Sale } from '../../../pages/POSTeller/POSTeller';
import roundUp from '../../../utils/roundUp';

type ModalProps = {
  onCloseModal: () => void;
  onRetrieveSale: (sale: Sale) => void;
  onGoingSaleId: string;
};

function RetrieveSales({
  onCloseModal,
  onRetrieveSale,
  onGoingSaleId,
}: ModalProps) {
  const [search, setSearch] = React.useState('');

  const localSales = React.useMemo(() => {
    const sales = getLocallySavedSales().filter(
      fndSale =>
        !isEmpty(fndSale.createdAt) &&
        moment(fndSale.createdAt, true).isValid() &&
        fndSale.id !== onGoingSaleId, // Filter out sale that is already on going
    ) as Sale[];

    if (!search) return sales;

    return sales.filter(fndSale =>
      fndSale.customer?.name?.toLowerCase().includes(search.toLowerCase()),
    );
  }, [onGoingSaleId, search]);

  const handleOnRetrieveSale = (sale: Sale) => {
    removeLocallyStoredSale(sale);
    onRetrieveSale(sale);
    onCloseModal();
  };

  return (
    <Modal onClose={onCloseModal} show onHide={() => false}>
      <div className="rounded-md bg-white min-w-[700px]">
        <div className="flex flex-col p-5">
          <div className="flex flex-row justify-between items-center gap-4 mb-2">
            <h3 className="text-pos-black text-[20px] font-semibold inline-flex whitespace-pre">
              Sales On Hold
            </h3>

            <div className="relative flex flex-row items-center">
              <Icon
                id="iconSearch"
                className="absolute w-[15px] h-[15px] my-auto top-0 bottom-0 left-4 fill-gray-300 stroke-gray-300"
              />
              <Input
                name="q"
                placeholder="Search by customer"
                value={search}
                className="!pl-[38px] w-[400px]"
                onChange={event => setSearch(event.target.value)}
              />
            </div>
          </div>

          <div className="mt-2 mb-2 overflow-x-auto overflow-y-auto relative max-h-[500px] min-h-[200px]">
            <table className="table-auto border-collapse w-full whitespace-no-wrap bg-white table-striped relative">
              <thead>
                <tr className="text-left bg-pos-header-bg sticky top-0 z-10">
                  <th className="!text-xbase font-semibold">#</th>
                  <th className="!text-xbase font-semibold">Date</th>
                  <th className="!text-xbase font-semibold">Cashier</th>
                  <th className="!text-xbase font-semibold">Customer</th>
                  <th className="!text-xbase font-semibold">Total</th>
                  <th className="!text-xbase font-semibold">Action</th>
                </tr>
              </thead>
              <tbody className="relative">
                {localSales.length === 0 ? (
                  <tr className="flex absolute inset-0 bg-[#f2f2f2] bg-opacity-75 transition-opacity">
                    <td
                      colSpan={8}
                      rowSpan={7}
                      className="!border-none w-full h-full"
                    >
                      <div className="fixed left-[50%] translate-x-[-50%] top-[50%] flex flex-col items-center justify-center p-4 font-normal">
                        <span className="text-pos-black test-sm">
                          No sales on hold!
                        </span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  localSales.map((fndSale, index) => (
                    <tr>
                      <td className="!text-sm">{index + 1}</td>
                      <td className="!text-sm">
                        {moment(fndSale.createdAt).format('DD-MM-YYYY')}
                      </td>
                      <td className="!text-sm">
                        {fndSale.cashier?.name || '-'}
                      </td>
                      <td className="!text-sm">
                        {fndSale.customer?.name || '-'}
                      </td>
                      <td className="!text-sm !font-semibold">
                        {roundUp(fndSale.total, 2).toFixed(2)}
                      </td>
                      <td>
                        <div>
                          <button
                            type="button"
                            onClick={() => handleOnRetrieveSale(fndSale)}
                            className="bg-pos-green border border-[rgba(27,31,36,0.15)] 
                          inline-flex py-2 px-3 text-white text-[13px] leading-none rounded-md cursor-pointer"
                          >
                            Retrieve
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default RetrieveSales;
